// Art.js
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Conill1 from "./images/Art/conill - 1.webp";
import Conill2 from "./images/Art/conill - 2.webp";
import Conill3 from "./images/Art/conill - 3.webp";
import Conill4 from "./images/Art/conill - 4.webp";
import Conill3New from "./images/Art/conill - Conill 3 - 2025.webp";
import Conill5 from "./images/Art/conill - Conill 5 - 2025.webp";
import Conill6 from "./images/Art/conill - Conill 6 - 2025.webp";
import Conill7 from "./images/Art/conill - Conill 7 - 2026.webp";
import Conill8 from "./images/Art/conill - Conill 8 - 2026.webp";
import Conill9 from "./images/Art/conill - Conill 9 - 2026.webp";
import Caixes2 from "./images/Art/caixes - 2.webp";
import Caixes3 from "./images/Art/caixes - 3.webp";
import Caixes4 from "./images/Art/caixes - 4.webp";
import Caixes5 from "./images/Art/caixes - 5.webp";
import Caixes6 from "./images/Art/caixes - 6.webp";
import Caixes7 from "./images/Art/caixes - 7.webp";
import Caixes8 from "./images/Art/caixes - 8.webp";
import Caixes9 from "./images/Art/caixes - 9.webp";
import Caixes11 from "./images/Art/caixes - 11.webp";
import Caixes12 from "./images/Art/caixes - 12.webp";
import Caixes13 from "./images/Art/caixes - 13.webp";
import Caixes14 from "./images/Art/caixes - 14.webp";
import Caixes15 from "./images/Art/caixes - 15.webp";
import Caixes16 from "./images/Art/caixes - 16.webp";
import Caixes17 from "./images/Art/caixes - 17.webp";
import Caixes18 from "./images/Art/caixes - 18.webp";
import Caixes19 from "./images/Art/caixes - 19.webp";
import Goa1 from "./images/Art/goa - 1.webp";
import Goa2 from "./images/Art/goa - 2.webp";
import Goa3 from "./images/Art/goa - 3.webp";
import Goa4 from "./images/Art/goa - 4.webp";
import Goa5 from "./images/Art/goa - 5.webp";
import Goa6 from "./images/Art/goa - 6.webp";
import Clementines1 from "./images/Art/clementines - Clementines 1 - 2021.webp";
import Clementines2 from "./images/Art/clementines - Clementines 2 - 2021.webp";
import Clementines3 from "./images/Art/clementines - Clementine 3 - 2021.webp";
import ClementinesOrange from "./images/Art/clementines - Orange - 2019.webp";
import Other20191 from "./images/Art/other2019 - Face - 2019.webp";
import Other20192 from "./images/Art/other2019 - Fish - 2019.webp";
import Other20193 from "./images/Art/other2019 - Fundacio Miro - 2019.webp";
import Other20194 from "./images/Art/other2019 - Fundacio Miro Plano - 2019.webp";
import Other20195 from "./images/Art/other2019 - Lange Kerkstraat Te Montfoort - 2019.webp";
import Other20196 from "./images/Art/other2019 - Man Statue - 2019.webp";
import Other20197 from "./images/Art/other2019 - Sillot Des Rencli - 2019.webp";
import Other20198 from "./images/Art/other2019 - Vorruit - 2019.webp";
import Other20199 from "./images/Art/other2019 - Vorruit 2 - 2019.webp";
import Other201910 from "./images/Art/other2019 - Untitled - 2019.webp";
import Other20211 from "./images/Art/other2021 - Breast - 2021.webp";
import Other20212 from "./images/Art/other2021 - Olives - 2021.webp";
import Other20213 from "./images/Art/other2021 - Still life - 2021.webp";
import Llibre1 from "./images/Art/Llibre del carrer - Bahawalpur - 2024.webp";
import Llibre2 from "./images/Art/Llibre del carrer - Blue tomates - 2024.webp";
import Llibre3 from "./images/Art/Llibre del carrer - Nemo - 2024.webp";
import Llibre4 from "./images/Art/Llibre del carrer - Polska – 2024.webp";
import Llibre5 from "./images/Art/Llibre del carrer - Republique Centrafricaine - 2024.webp";
import Llibre6 from "./images/Art/Llibre del carrer - Sardana - 2024.webp";
import Llibre7 from "./images/Art/Llibre del carrer - Untitled - 2024.webp";
import Llibre8 from "./images/Art/Llibre del carrer - Untitled - 2024 2.webp";
import Llibre9 from "./images/Art/Llibre del carrer - Untitled - 2024 3.webp";
import Llibre10 from "./images/Art/Llibre del carrer - Untitled - 2024 4.webp";
import Llibre11 from "./images/Art/Llibre del carrer - Untitled - 2024 5.webp";
import Llibre12 from "./images/Art/Llibre del carrer - Untitled - 2024 6.webp";
import Llibre13 from "./images/Art/Llibre del carrer - Untitled - 2024 7.webp";
import Llibre14 from "./images/Art/Llibre del carrer -Postes Afghanes - 2024 .webp";
import Gargots1 from "./images/Art/gargots - Basketball - 2022.webp";
import Gargots2 from "./images/Art/gargots - Blue vase - 2022.webp";
import Gargots3 from "./images/Art/gargots - Brasserie Lipp - 2022.webp";
import Gargots4 from "./images/Art/gargots - Chicken II - 2022.webp";
import Gargots5 from "./images/Art/gargots - Chicken - 2022.webp";
import Gargots6 from "./images/Art/gargots - Exploding heads - 2022.webp";
import Gargots7 from "./images/Art/gargots - Face I - 2022.webp";
import Gargots8 from "./images/Art/gargots - Face II - 2022.webp";
import Gargots9 from "./images/Art/gargots - Garden of flowers - 2022.webp";
import Gargots10 from "./images/Art/gargots - Goldamn Sachs.webp";
import Gargots11 from "./images/Art/gargots - Half a man - 2022.webp";
import Gargots12 from "./images/Art/gargots - Lady - 2022.webp";
import Gargots13 from "./images/Art/gargots - New profile pic - 2022.webp";
import Gargots14 from "./images/Art/gargots - Pink leaves - 2022.webp";
import Gargots15 from "./images/Art/gargots - Profile pic 2.webp";
import Gargots16 from "./images/Art/gargots - Roses - 2022.webp";
import Gargots17 from "./images/Art/gargots - Saturday I - 2022.webp";
import Gargots18 from "./images/Art/gargots - Unkempt plants - 2022.webp";
import Gargots19 from "./images/Art/gargots - Yellow vase - 2022.webp";
import Gargots20 from "./images/Art/gargots - Profile pic, close-up.webp";
import Gargots21 from "./images/Art/gargots - Untitled 1 - 2022.webp";
import Gargots22 from "./images/Art/gargots - Untitled 2 - 2022.webp";
import Gargots23 from "./images/Art/gargots - Untitled 22 Mar 2022 I - 2022.webp";
import Gargots24 from "./images/Art/gargots - Untitled 22 Mar 2022 II - 2022.webp";
import Gargots25 from "./images/Art/gargots - Untitled 22 Mar 2022 III - 2022.webp";
import Gargots26 from "./images/Art/gargots - Untitled 4 - 2022.webp";
import Gargots27 from "./images/Art/gargots - Untitled 6 - 2022.webp";
import Gargots28 from "./images/Art/gargots - Untitled 7 - 2022.webp";
import Gargots29 from "./images/Art/gargots - Untitled I 290322 2022 - 2022.webp";
import Gargots30 from "./images/Art/gargots - Untitled I Mar 22 - 2022.webp";
import Gargots31 from "./images/Art/gargots - Untitled II 290322 2022 - 2022.webp";
import Gargots32 from "./images/Art/gargots - Untitled II.webp";
import Gargots33 from "./images/Art/gargots - Untitled III 290322 2022 - 2022.webp";
import Gargots34 from "./images/Art/gargots - Untitled, 11 Mar - 2022.webp";
import Gargots35 from "./images/Art/gargots - Untitled - 2022.webp";
import Gargots36 from "./images/Art/gargots - Untitled, 5 March 2022 - 2022.webp";
import Gargots37 from "./images/Art/gargots - Untitled, 9 March - 2022.webp";
import Other20221 from "./images/Art/other2022 - Botanical garden - 2022.webp";
import Other20222 from "./images/Art/other2022 - Bull - 2022.webp";
import Other20223 from "./images/Art/other2022 - Bunny - 2022.webp";
import Other20224 from "./images/Art/other2022 - Door - 2019.webp";
import Other20225 from "./images/Art/other2022 - Garden - 2022.webp";
import Other20226 from "./images/Art/other2022 - Quiniela - 2022.webp";
import Other20227 from "./images/Art/other2022 - Temps de taronges - 2022.webp";
import Other20228 from "./images/Art/other2022 - Tomatoes - 2022.webp";
import Other20229 from "./images/Art/other2022 - Woman dressing herself - 2022.webp";
import Other202210 from "./images/Art/other2022 - Untitled (i) - 2022.webp";
import Other202211 from "./images/Art/other2022 - Untitled - 2022.webp";
import "./App.css";

function makeSlug(section, title, year) {
  return (section + "-" + title + (year ? "-" + year : ""))
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

// Custom grid icons with straight edges
const Grid3Icon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" stroke="currentColor" strokeWidth="1" />
    <line x1="5.67" y1="1" x2="5.67" y2="15" stroke="currentColor" strokeWidth="1" />
    <line x1="10.33" y1="1" x2="10.33" y2="15" stroke="currentColor" strokeWidth="1" />
    <line x1="1" y1="5.67" x2="15" y2="5.67" stroke="currentColor" strokeWidth="1" />
    <line x1="1" y1="10.33" x2="15" y2="10.33" stroke="currentColor" strokeWidth="1" />
  </svg>
);

const Grid2Icon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" stroke="currentColor" strokeWidth="1" />
    <line x1="8" y1="1" x2="8" y2="15" stroke="currentColor" strokeWidth="1" />
    <line x1="1" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="1" />
  </svg>
);

const Grid1Icon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="14" height="14" stroke="currentColor" strokeWidth="1" />
  </svg>
);

const ImageGrid = ({ items, onImageClick, gridColumns }) => {
  return (
    <div
      className="product-grid"
      style={{
        gridTemplateColumns: `repeat(${gridColumns}, 1fr)`
      }}
    >
      {items.map((item, index) => (
        <div key={index} style={{ minWidth: 0 }}>
          <div
            className="product-card"
            style={{
              aspectRatio: "1 / 1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => onImageClick(item)}
          >
            <img
              src={item.image}
              alt={item.title || item.caption}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
          {(item.title || item.year) && (
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              {item.title && (
                <p style={{ fontSize: "13px", fontWeight: "400", margin: "0 0 3px 0", wordBreak: "break-word" }}>
                  {item.title}
                </p>
              )}
              {item.year && (
                <p style={{ fontSize: "13px", color: "#666", margin: "0" }}>
                  {item.year}
                </p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const ImageModal = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        cursor: "pointer",
        padding: "24px",
        boxSizing: "border-box",
      }}
    >
      <img
        src={item.image}
        alt={item.title || "Expanded view"}
        style={{
          maxWidth: "100%",
          maxHeight: "calc(100% - 80px)",
          objectFit: "contain",
        }}
      />
      {(item.title || item.year || item.size) && (
        <div style={{ marginTop: "16px", textAlign: "center" }}>
          {item.title && (
            <span style={{ color: "#fff", fontSize: "13px", fontWeight: "400" }}>
              {item.title}
            </span>
          )}
          {item.year && (
            <span style={{ color: "#999", marginLeft: "8px", fontSize: "13px" }}>
              {item.year}
            </span>
          )}
          {item.size && (
            <span style={{ color: "#999", marginLeft: "8px", fontSize: "11px" }}>
              {item.size}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

function Art() {
  const { piece } = useParams();
  const navigate = useNavigate();
  const [showDescriptions, setShowDescriptions] = useState(true);
  const [gridColumns, setGridColumns] = useState(() => window.innerWidth <= 768 ? 3 : 2);

  const conillsItems = [
    { image: Conill9, title: "Conill 9", year: "2026", size: "19×13.5 cm" },
    { image: Conill7, title: "Conill 7", year: "2026", size: "19×13.5 cm" },
    { image: Conill8, title: "Conill 8", year: "2026", size: "19×13.5 cm" },
    { image: Conill1, title: "Conill 1", year: "2025", size: "19×13.5 cm" },
    { image: Conill2, title: "Conill 2", year: "2025", size: "19×13.5 cm" },
    { image: Conill3, title: "Conill 3", year: "2025", size: "19×13.5 cm" },
    { image: Conill4, title: "Conill 4", year: "2025", size: "19×13.5 cm" },
    { image: Conill3New, title: "Conill 3", year: "2025", size: "19×13.5 cm" },
    { image: Conill5, title: "Conill 5", year: "2025", size: "19×13.5 cm" },
    { image: Conill6, title: "Conill 6", year: "2025", size: "13.5×19 cm" },
  ];

  const caixesDePurosItems = [
    { image: Caixes8, title: "Ajman", year: "2024", size: "14×13 cm" },
    { image: Caixes9, title: "Yellow", year: "2024", size: "25×21 cm" },
    { image: Caixes12, title: "Mongolia", year: "2024", size: "14×16 cm" },
    { image: Caixes13, title: "Heroes del aire", year: "2024", size: "15×18 cm" },
    { image: Caixes14, title: "Republique Rwandaise", year: "2024", size: "16×19 cm" },
    { image: Caixes15, title: "The Mutawakaelite", year: "2024", size: "15×12 cm" },
    { image: Caixes16, title: "Esztergomi", year: "2024", size: "17×12 cm" },
    { image: Caixes17, title: "Serie Le Hoyo", year: "2024", size: "13×13 cm" },
    { image: Caixes18, title: "Untitled", year: "2024", size: "23×14 cm" },
    { image: Caixes19, title: "Grenada", year: "2024", size: "23×14 cm" },
    { image: Caixes6, title: "Johan Cruyff", year: "2023", size: "12×21 cm" },
    { image: Caixes7, title: "Maradona", year: "2023", size: "25×14 cm" },
    { image: Caixes11, title: "Manama", year: "2023", size: "14×16 cm" },
    { image: Caixes2, title: "Buffalo", year: "2022", size: "18×17 cm" },
    { image: Caixes3, title: "Antelope", year: "2022", size: "18×18 cm" },
    { image: Caixes4, title: "Warthogs", year: "2022", size: "17×14 cm" },
    { image: Caixes5, title: "Backspace", year: "2022", size: "18×16 cm" },
  ];

  const goaItems = [
    { image: Goa1, title: "Goa 1", year: "2016", size: "29×21 cm" },
    { image: Goa2, title: "Goa 2", year: "2016", size: "29×21 cm" },
    { image: Goa3, title: "Goa 3", year: "2016", size: "29×21 cm" },
    { image: Goa4, title: "Goa 4", year: "2016", size: "29×21 cm" },
    { image: Goa5, title: "Goa 5", year: "2016" },
    { image: Goa6, title: "Goa 6", year: "2016" },
  ];

  const clementinesItems = [
    { image: Clementines1, title: "Clementines 1", year: "2021", size: "21×16 cm" },
    { image: Clementines2, title: "Clementines 2", year: "2021", size: "21×16 cm" },
    { image: Clementines3, title: "Clementine 3", year: "2021", size: "9×8.5 cm" },
    { image: ClementinesOrange, title: "Orange", year: "2019" },
  ];

  const other2019Items = [
    { image: Other20196, title: "Man Statue", year: "2019" },
    { image: Other20195, title: "Lange Kerkstraat Te Montfoort", year: "2019" },
    { image: Other20197, title: "Sillot Des Rencli", year: "2019" },
    { image: Other20198, title: "Vorruit", year: "2019" },
    { image: Other20192, title: "Fish", year: "2019" },
    { image: Other20191, title: "Face", year: "2019" },
    { image: Other20193, title: "Fundacio Miro", year: "2019" },
    { image: Other20194, title: "Fundacio Miro Plano", year: "2019" },
    { image: Other20199, title: "Vorruit 2", year: "2019" },
    { image: Other201910, title: "Untitled", year: "2019" },
  ];

  const other2021Items = [
    { image: Other20211, title: "Breast", year: "2021", size: "21×16 cm" },
    { image: Other20212, title: "Olives", year: "2021", size: "27×16 cm" },
    { image: Other20213, title: "Still life", year: "2021" },
  ];

  const llibresDelCarrerItems = [
    { image: Llibre1, title: "Bahawalpur", year: "2024", size: "19×13.5 cm" },
    { image: Llibre2, title: "Blue tomates", year: "2024", size: "19×13.5 cm" },
    { image: Llibre3, title: "Nemo", year: "2024", size: "19×13.5 cm" },
    { image: Llibre4, title: "Polska", year: "2024", size: "19×13.5 cm" },
    { image: Llibre5, title: "Republique Centrafricaine", year: "2024", size: "19×13.5 cm" },
    { image: Llibre6, title: "Sardana", year: "2024", size: "19×13.5 cm" },
    { image: Llibre14, title: "Postes Afghanes", year: "2024", size: "19×13.5 cm" },
    { image: Llibre7, title: "Untitled", year: "2024", size: "19×13.5 cm" },
    { image: Llibre8, title: "Untitled 2", year: "2024", size: "19×13.5 cm" },
    { image: Llibre9, title: "Untitled 3", year: "2024", size: "19×13.5 cm" },
    { image: Llibre10, title: "Untitled 4", year: "2024", size: "19×13.5 cm" },
    { image: Llibre11, title: "Untitled 5", year: "2024", size: "19×13.5 cm" },
    { image: Llibre12, title: "Untitled 6", year: "2024", size: "19×13.5 cm" },
    { image: Llibre13, title: "Untitled 7", year: "2024", size: "19×13.5 cm" },
  ];

  const gargotsItems = [
    { image: Gargots1, title: "Basketball", year: "2022", size: "16.5×13 cm" },
    { image: Gargots2, title: "Blue vase", year: "2022", size: "21×16 cm" },
    { image: Gargots3, title: "Brasserie Lipp", year: "2022", size: "18.4×9.4 cm" },
    { image: Gargots4, title: "Chicken II", year: "2022", size: "21×16 cm" },
    { image: Gargots5, title: "Chicken", year: "2022", size: "21×16 cm" },
    { image: Gargots6, title: "Exploding heads", year: "2022" },
    { image: Gargots7, title: "Face I", year: "2022", size: "21×16 cm" },
    { image: Gargots8, title: "Face II", year: "2022", size: "21×16 cm" },
    { image: Gargots9, title: "Garden of flowers", year: "2022", size: "21×16 cm" },
    { image: Gargots10, title: "Goldamn Sachs" },
    { image: Gargots11, title: "Half a man", year: "2022", size: "21×16 cm" },
    { image: Gargots12, title: "Lady", year: "2022", size: "21×16 cm" },
    { image: Gargots13, title: "New profile pic", year: "2022", size: "21×16 cm" },
    { image: Gargots14, title: "Pink leaves", year: "2022", size: "21×16 cm" },
    { image: Gargots15, title: "Profile pic 2", size: "21×16 cm" },
    { image: Gargots16, title: "Roses", year: "2022", size: "21×16 cm" },
    { image: Gargots17, title: "Saturday I", year: "2022", size: "21×16 cm" },
    { image: Gargots18, title: "Unkempt plants", year: "2022", size: "21×16 cm" },
    { image: Gargots19, title: "Yellow vase", year: "2022", size: "21×16 cm" },
    { image: Gargots20, title: "Profile pic, close-up" },
    { image: Gargots21, title: "Untitled 1", year: "2022", size: "21×16 cm" },
    { image: Gargots22, title: "Untitled 2", year: "2022", size: "21×16 cm" },
    { image: Gargots23, title: "Untitled 22 Mar 2022 I", year: "2022", size: "16×21 cm" },
    { image: Gargots24, title: "Untitled 22 Mar 2022 II", year: "2022", size: "16×21 cm" },
    { image: Gargots25, title: "Untitled 22 Mar 2022 III", year: "2022", size: "16×21 cm" },
    { image: Gargots26, title: "Untitled 4", year: "2022", size: "21×16 cm" },
    { image: Gargots27, title: "Untitled 6", year: "2022", size: "21×16 cm" },
    { image: Gargots28, title: "Untitled 7", year: "2022", size: "21×16 cm" },
    { image: Gargots29, title: "Untitled I 290322 2022", year: "2022", size: "21×16 cm" },
    { image: Gargots30, title: "Untitled I Mar 22", year: "2022", size: "21×16 cm" },
    { image: Gargots31, title: "Untitled II 290322 2022", year: "2022", size: "21×16 cm" },
    { image: Gargots32, title: "Untitled II", year: "2022" },
    { image: Gargots33, title: "Untitled III 290322 2022", year: "2022", size: "21×16 cm" },
    { image: Gargots34, title: "Untitled, 11 Mar", year: "2022", size: "21×16 cm" },
    { image: Gargots35, title: "Untitled", year: "2022", size: "21×16 cm" },
    { image: Gargots36, title: "Untitled, 5 March 2022", year: "2022", size: "21×16 cm" },
    { image: Gargots37, title: "Untitled, 9 March", year: "2022", size: "21×16 cm" },
  ];

  const other2022Items = [
    { image: Other20221, title: "Botanical garden", year: "2022", size: "21×16 cm" },
    { image: Other20222, title: "Bull", year: "2022", size: "21×16 cm" },
    { image: Other20223, title: "Bunny", year: "2022", size: "16×21 cm" },
    { image: Other20224, title: "Door", year: "2019", size: "21×16 cm" },
    { image: Other20225, title: "Garden", year: "2022", size: "26×17 cm" },
    { image: Other20226, title: "Quiniela", year: "2022" },
    { image: Other20227, title: "Temps de taronges", year: "2022", size: "21×16 cm" },
    { image: Other20228, title: "Tomatoes", year: "2022", size: "21×16 cm" },
    { image: Other20229, title: "Woman dressing herself", year: "2022", size: "21×16 cm" },
    { image: Other202210, title: "Untitled (i)", year: "2022" },
    { image: Other202211, title: "Untitled", year: "2022" },
  ];

  // Combine all items and sort chronologically for "Index" view
  const allItemsCombined = [
    ...conillsItems,
    ...caixesDePurosItems,
    ...gargotsItems,
    ...other2022Items,
    ...other2021Items,
    ...clementinesItems,
    ...other2019Items,
    ...llibresDelCarrerItems,
    ...goaItems,
  ].sort((a, b) => {
    // First sort by year (descending)
    const yearDiff = parseInt(b.year) - parseInt(a.year);
    if (yearDiff !== 0) return yearDiff;
    // If same year, sort by title (reverse alphabetical)
    return b.title.localeCompare(a.title);
  });

  // Build slug ↔ item maps for shareable URLs
  const slugToItem = {};
  const itemToSlug = new Map();
  const sectionedItems = [
    ["conills", conillsItems],
    ["caixes", caixesDePurosItems],
    ["gargots", gargotsItems],
    ["other", other2022Items],
    ["other2021", other2021Items],
    ["clementines", clementinesItems],
    ["other2019", other2019Items],
    ["llibres", llibresDelCarrerItems],
    ["goa", goaItems],
  ];
  for (const [section, items] of sectionedItems) {
    for (const item of items) {
      const slug = makeSlug(section, item.title, item.year);
      if (!slugToItem[slug]) {
        slugToItem[slug] = item;
        itemToSlug.set(item, slug);
      }
    }
  }
  const expandedImage = slugToItem[piece] || null;
  const handleImageClick = (item) => {
    const slug = itemToSlug.get(item);
    if (slug) navigate(`/art/${slug}`);
  };
  const handleClose = () => navigate("/art");

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>
          {expandedImage
            ? `${expandedImage.title}${expandedImage.year ? `, ${expandedImage.year}` : ""} — Felix Ingla`
            : "Art — Felix Ingla"}
        </title>
        <meta
          name="description"
          content={expandedImage
            ? `${expandedImage.title}${expandedImage.year ? `, ${expandedImage.year}` : ""}${expandedImage.size ? `. ${expandedImage.size}` : ""}. Artwork by Felix Ingla.`
            : "Artwork by Felix Ingla — drawings, paintings, and collages made from 2016 to today."}
        />
      </Helmet>
      <ImageModal
        item={expandedImage}
        onClose={handleClose}
      />
      <article>
        <p>
          <mark style={{ backgroundColor: "#F0E27B", padding: "2px 4px" }}>
            A selection of my artwork
          </mark>
          . See more on{" "}
          <a
            href="https://instagram.com/felixingla"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          . To enquire about a piece, message me on Instagram or email
          felix@pedra.ai.
        </p>

        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "60px",
          marginBottom: "15px",
          gap: "20px",
          flexWrap: "wrap"
        }}>
          <div style={{
            display: "flex",
            gap: "0px"
          }}>
            <button
              onClick={() => setShowDescriptions(true)}
              style={{
                padding: "10px 16px",
                fontSize: "13px",
                border: "1px solid #000",
                borderRight: "none",
                backgroundColor: showDescriptions ? "#000" : "#fff",
                color: showDescriptions ? "#fff" : "#000",
                cursor: "pointer",
                fontWeight: "400",
                fontFamily: "inherit"
              }}
            >
              Work
            </button>
            <button
              onClick={() => setShowDescriptions(false)}
              style={{
                padding: "10px 16px",
                fontSize: "13px",
                border: "1px solid #000",
                backgroundColor: !showDescriptions ? "#000" : "#fff",
                color: !showDescriptions ? "#fff" : "#000",
                cursor: "pointer",
                fontWeight: "400",
                fontFamily: "inherit"
              }}
            >
              Index
            </button>
          </div>

          <div style={{
            display: "flex"
          }}>
            {[
              { cols: 3, icon: Grid3Icon },
              { cols: 2, icon: Grid2Icon },
              { cols: 1, icon: Grid1Icon }
            ].map(({ cols, icon: Icon }, idx) => (
              <button
                key={cols}
                onClick={() => setGridColumns(cols)}
                style={{
                  padding: "10px",
                  borderTop: "1px solid #000",
                  borderBottom: "1px solid #000",
                  borderLeft: "1px solid #000",
                  borderRight: idx === 2 ? "1px solid #000" : "none",
                  backgroundColor: gridColumns === cols ? "#000" : "#fff",
                  color: gridColumns === cols ? "#fff" : "#000",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Icon />
              </button>
            ))}
          </div>
        </div>

        {showDescriptions ? (
          <>
            <h2 style={{ marginTop: "35px" }} className="section-title">
              Conills
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              For some reason, whenever I start a new project I pick the rabbit as the symbol for it. No conscious reason why, I just do. Every project at my old job got a rabbit. The first logo for Pedra was a rabbit. So I decided to draw 100 of them, using the colors of the Mediterranean sea reflected on water (I don't know why either, I just think it looks cool).
            </p>
            <ImageGrid
              items={conillsItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />

            <h2 style={{ marginTop: "70px" }} className="section-title">
              Caixes de Puros
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              My parents and grandfather were heavy cigar smokers. Every night when I was a kid our living room looked like a hot box of cigar smoke. Naturally, there were cigar boxes everywhere, and I always thought they looked cool and interesting. I was drawn to using them as a medium, always with melancholic materials—old stamps, old pictures I took—to amplify the melancholic memory of cigar boxes in my life.
            </p>
            <ImageGrid
              items={caixesDePurosItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />

            <h2 style={{ marginTop: "70px" }} className="section-title">
              Gargots i formes
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              Pencil, pen, Caran d'Ache and acrylic paint on paper and mixed paper materials.
            </p>
            <ImageGrid
              items={gargotsItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />

            <h2 style={{ marginTop: "70px" }} className="section-title">
              Llibres del Carrer
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              Collages made on top of two books I found on the street. Idea explorations related to other works—you can see the stamps I use in caixes de puros and shapes that might resemble rabbits. A bit nonsensical regardless.
            </p>
            <ImageGrid
              items={llibresDelCarrerItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />

            <h2 style={{ marginTop: "70px" }} className="section-title">
              Clementines
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              Posca and Caran d'Ache on paper and mixed paper materials.
            </p>
            <ImageGrid
              items={clementinesItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />

            <h2 style={{ marginTop: "70px" }} className="section-title">
              Goa
            </h2>
            <p style={{ fontFamily: "Inter, sans-serif", marginTop: "12px", marginBottom: "20px" }}>
              Made during a trip to Goa, India when I was 17. Film camera and cheap materials—dark plastic bags and whatever I could find.
            </p>
            <ImageGrid
              items={goaItems}
              onImageClick={handleImageClick}
              gridColumns={gridColumns}
            />
          </>
        ) : (
          <ImageGrid
            items={allItemsCombined}
            onImageClick={handleImageClick}
            gridColumns={gridColumns}
          />
        )}
      </article>
      <br />
      <br />
    </>
  );
}

export default Art;
